import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
interface RadioOptionButtonProps {
  label: string;
  value: string;
  position?: "left" | "right" | "center";
  selectedOption?: string;
  onClick: () => void;
}
const RadioOptionButton = t0 => {
  const $ = _c(11);
  const {
    label,
    value,
    position: t1,
    selectedOption,
    onClick
  } = t0;
  const position = t1 === undefined ? "right" : t1;
  const t2 = `${value}-button`;
  const t3 = `py-3 border rounded-lg ${selectedOption === value ? "bg-[#F6F2FF] border-[#6B00D7]" : "text-[#5A5C63] border-[#E1E2E4]"}`;
  const t4 = `px-5 font-medium ${selectedOption === value ? "text-primary" : "text-[#5A5C63]"}`;
  let t5;
  if ($[0] !== position) {
    t5 = {
      textAlign: position
    };
    $[0] = position;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== label || $[3] !== t4 || $[4] !== t5) {
    t6 = <Typography size={15} lineHeight={22} className={t4} style={t5}>{label}</Typography>;
    $[2] = label;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onClick || $[7] !== t2 || $[8] !== t3 || $[9] !== t6) {
    t7 = <CustomButton key={t2} className={t3} onClick={onClick}>{t6}</CustomButton>;
    $[6] = onClick;
    $[7] = t2;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default RadioOptionButton;